Monitoring.Views ||= {}

class AccountSettings.PrioritizationSelectorView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/prioritization_selector"]

  events:
    'click .add_filter_btn': 'onClickAdd'
    'click .close_selector_btn': 'onClickClose'
  tagName: 'div'
  className: 'proioritization_selection_view_wrapper'

  initialize: (@options = {}) ->
    @settings = @options.settings
    @public_filters = @options.public_filters


  render: =>
    @$el.html(@template({settings: @settings, public_filters: @public_filters}))
    @

  onClickClose:(event)->
    event.stopPropagation()
    @trigger('prioritization:selector:click:close')

  onClickAdd:(event)=>
    event.stopPropagation()
    selected_filter = @$el.find('#acd-filter-options-filter option:selected')[0]
    filter_id = selected_filter.value
    folder = 'Public'
    if $(selected_filter).attr("data-group-id")
        folder = $(selected_filter).attr("data-group-id")
    filter = {filter_id: filter_id, filter_name: folder + ' | ' + $(selected_filter).attr("data-filter-name") }
    order_text = @$el.find('#acd-filter-options-order option:selected')[0].text
    order_code = @$el.find('#acd-filter-options-order option:selected')[0].value
    order = {order_code: order_code, order_text: order_text}
    @trigger('prioritization:click:add', filter, order)
    @trigger('prioritization:selector:click:close')
